<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <div class="main-head">
          <div class="row">
            <div class="col-md-8">
              <div class="head-left">
                <router-link to="/subjects" class="m-menu__link btn btn-info">{{course_name}}</router-link>
                <h2>{{topic_details.name}}</h2>
                <div class="sub-row">
                  <div class="head-topic">{{course_duration}} Hours</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="head-right">
                <a href="#" class="btn btn-info" @click="goBacktoChapters()">Back</a>
              </div>
            </div>
          </div>
        </div>
        <!--begin::Portlet-->
        <div class="m-portlet topic-area">
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <!-- begin::Topic Video Card Block -->
                <div class="row">
                  <div class="col-md-12 margin-b-30">
                    <div class="card description">
                      <div class="card-header">Description</div>
                      <div class="card-body">
                        {{topic_details.text}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="videoId == null">
                  <div class="col-md-12">
                    <div class="no-video-top-bar">
                        <div class="row">
                          <div class="col-md-6">
                            <button  v-if="showQuizeButton" @click="goToQuiz()" class="btn btn-info quiz-btn">Continue to Quiz</button>
                          </div>
                          <div class="col-md-2 btn-area">
                            <a @click.prevent="scrollToElement('assignmentBlock')" class="btn btn-info assignment">{{assignmentCount}} Assignments</a>
                          </div>
                          <div class="col-md-2 btn-area">
                            <a @click.prevent="scrollToElement('materialBlock')" class="btn btn-info mater">{{meterialCount}} Materails</a>
                          </div>
                          <div class="col-md-2 btn-area">
                            <a @click.prevent="scrollToElement('quizBlock')" class="btn btn-info question">{{quizCount}} Questions</a>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-md-9 padding-r-7">
                    <div class="video_block">
                      <div class="card topic_card_wrapper mb-4">
                        <h5 class="card-header">Topic Video</h5>
                        <div class="card-body video-frame">
                          <div class="video_wrapper">
                            <Uploadedvideo v-if="videoType === 'uploaded'" :videoId=videoId @change-video-desc="changeVideoDesc"></Uploadedvideo>
                            <Vimeovideo v-if="videoType === 'vimeo'" :videoId=videoId @change-video-desc="changeVideoDesc"></Vimeovideo>
                            <Youtubevideo v-if="videoType === 'youtube'" :videoId=videoId @change-video-desc="changeVideoDesc"></Youtubevideo>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3  padding-l-7">
                    <div class="video_desc">
                      <div class="inner-text" id="video_play_pending text" v-if="videopPlayPending && !showQuizeButton">
                          <div class="quiz-icon">
                            <img src="media/icons/quiz.png" />
                          </div>
                        <div class="m-text-muted m--margin-bottom-15">Make sure you watch and understand the video tutorial<br>
                          as you will be required to answer few questions based on this</div>
                      </div>
                      <div class="inner-text" id="video_play_completed text" v-if="videoPlayCompleted && !showQuizeButton">
                        <div class="quiz-icon">
                          <img src="media/icons/quiz.png" />
                        </div>
                        <div class="m-text-muted m--margin-bottom-15">If you have watched and understood this video,<br>
                          click here to continue to your induction.</div>
                        <button @click="goToQuiz()" class="btn btn-info">
                          Continue to Quiz
                        </button>
                      </div>
                      <div class="inner-text" id="featureOptionQuiz text" v-if="showQuizeButton">
                        <div class="quiz-icon">
                          <img src="media/icons/quiz.png" />
                        </div>
                        <div class="m-text-muted m--margin-bottom-15">click here to continue to your induction.</div>
                        <button @click="goToQuiz()" class="btn btn-info">
                          Continue to Quiz
                        </button>
                      </div>
                    </div>
                    <div class="btn-area">
                      <div class="row">
                        <div class="col-sm-12">
                          <a @click.prevent="scrollToElement('assignmentBlock')" class="btn btn-info assignment">{{assignmentCount}} Assignments</a>
                        </div>
                        <div class="col-sm-12">
                          <a @click.prevent="scrollToElement('materialBlock')" class="btn btn-info mater">{{meterialCount}} Materails</a>
                        </div>
                        <div class="col-sm-12">
                          <a @click.prevent="scrollToElement('quizBlock')" class="btn btn-info question">{{quizCount}} Questions</a>
                        </div>
                      </div>
                    </div>
                    <div class="btn-area">
                      <div class="row">
                        <div class="col-sm-4">
                          <!-- <a href="#" class="btn btn-info feedback">Send Feedback</a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 padding-r-7 margin-b">
                    <!-- begin::Documents Card Block -->
                    <div id="materialBlock" class="card topic_card_wrapper mb-4 inner-list">
                      <h5 class="card-header">Course Materials</h5>
                      <div class="card-body control-body">
                        <div class="documents_wrapper">
                          <div class="documents_block">
                            <div class="document_item row" v-for="(documentItem, index) in this.documents" :key="index">
                              <div class="col-md-12">
                                <div class="item-row">
                                  <div class="row">
                                    <div class="document_icon col-9">
                                      <img src="/media/files/doc.svg" alt="" width="15px">
                                      <span>{{documentItem.title}}</span>
                                    </div>
                                    <div class="document_download col-3">
                                      <a :href="document_url+'/'+documentItem.file" target="_blank">
                                        <img src="/media/icons/download.png" alt="" width="23px">
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End::Documents Card Block -->
                  </div>
                  <div class="col-md-6 padding-l-7 margin-b">
                    <!-- begin::Assignments Card Block -->
                    <div id="assignmentBlock" class="card topic_card_wrapper mb-4 inner-list">
                      <h5 class="card-header">Assignments</h5>
                      <div class="card-body control-body">
                        <div class="assignment_wrapper">
                          <div class="assignment_block">
                            <div class="item-row" v-for="(assignmentItem, index) in this.assignments" :key="index">
                              <div class="row">
                                <div class="document_icon col-md-12">
                                  <img src="/media/files/doc.svg" alt="" width="15px">
                                  <span class="title-over">{{assignmentItem.assignment.title}}</span>
                                  <a class="doc-link" :href="assignment_url + '/'+assignmentItem.assignment.file" target="_blank">
                                    <img src="/media/icons/download.png" alt="" width="23px">
                                  </a>
                                  <span class="d-md-block date-over publish"><b class="main-b publish">Publish Date:</b> {{assignmentItem.start_date != null ?  assignmentItem.start_date : ''}}</span>
                                  <span class="d-md-block date-over"><b class="main-b due">Due Date:</b> {{assignmentItem.due_date != null ?  assignmentItem.due_date : ''}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="submit-row">
                              <a class="btn btn-info" data-toggle="modal" data-target="#upload-modal">Submit your Assignment</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End::Assignments Card Block -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 padding-r-7">
                    <div class="card topic_card_wrapper mb-0 assignment-eva">
                      <h5 class="card-header">Assignments Evaluation</h5>
                      <div class="card-body control-body">
                        <div class="m-widget5">
                          <div class="m-widget5__item" v-for="(item, index) in uploads" :key="index">
                            <div class="m-widget5__content">
                              <h5 class="m-widget5__title">{{item.assignment}}</h5>
                              <div class="set-time">
                                <div class="half">
                                  <span class="m-widget5__info-label m--font-danger">Due On:</span>
                                  <span class="m-widget5__info-date"> {{item.due_date}}</span>
                                </div>
                                <div class="half">
                                  <span class="m-widget5__info-label m--font-info">Submitted :</span>
                                  <span v-if="item.student_upload !== null" class="m-widget5__info-date"> {{item.student_upload.submit_date}}</span>
                                  <span v-if="item.student_upload === null" class="m-widget5__info-date m--font-danger"> No</span>
                                </div>
                              </div>
                              <div class="attach-file">
                                <a v-if="item.student_upload !== null" :href="api_url + '/student-uploads/' +item.student_upload.file" target="_BLANK">Attach File <img src="/media/files/file.png" /></a>
                              </div>
                              <div class="m-widget5__info"></div>
                              <span class="m-widget5__desc"></span>
                            </div>
                            <div class="m-widget5__stats2">
                              <span class="m-widget5__votes m--font-success" style="font-weight: 600"  v-if="item.student_upload !== null">{{item.student_upload.marks}}/{{item.student_upload.out_of}}</span>
                              <span class="m-widget5__votes" style="font-weight: 600"  v-else>0</span>
                              <br>
                              <span class="m-widget5__votes" style="font-weight: 500">Marks</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="quizBlock" class="col-md-6 padding-l-7">
                    <div class="card topic_card_wrapper mb-0">
                      <h5 class="card-header">Questions</h5>
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="m-widget5 control-body">
                            <div class="m-widget5__item" v-for="(item, index) in quizAnswerDetails" :key="index">
                              <div class="m-widget5__content">
                                <h4 class="m-widget5__title">
                                  <span class="mark-res" style="color:green" v-if="item.correct === 1">Correct</span>
                                  <span class="mark-res" style="color:red" v-if="item.correct === 0">Wrong</span>
                                  <span class="mark-res" v-if="item.correct == 2">Skipped</span>
                                  <span class="m-widget5__info-date m--font-info">{{ item.date }}</span>
                                </h4>
                                <div class="m-widget5__desc quest">{{ index + 1 }}. {{ item.question}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center padding-r-7 mt-3">
                    <input type="hidden" name="topicCompleteId">
                    <div id="app-cover" class="app-cover">
                      <div class="row">
                        <div class="toggle-button-cover">
                          <h3>I have successfully completed this Topic.</h3>
                          <div class="button-cover">
                            <div class="button b2" id="button-10">
                              <input @click="setCompleteTopic" type="checkbox" class="checkbox" :checked="!topicCompleteStatus">
                              <div class="knobs">
                                <span>NO</span>
                              </div>
                              <div class="layer"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End::Topic Video Card Block -->
              </div>
            </div>
          </div>
          <div class="loader_wrapper" v-if="isLoading">
            <div class="loader_block">
              <loading :active.sync="isLoading" :color="'#f7941d'" :loader="'spinner'" :can-cancel="false" :is-full-page="false"></loading>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
    <transition name="modal" v-if="showErrorModal">
      <div class="container">
        <div class="error_modal_overlay">
          <div class="popup_modal">
             <div class="card modal_wrapper mb-4">
                <h4 class="card-header">Warning.! Please Allow the camera</h4>
                <div class="card-body">
                  <div><h6><b>Mobile Users:</b></h6></div>
                  <div><strong>Android:</strong><br>Go setting -> App -> Permission -> Select Browser -> Allow Camera</div>
                  <div><strong>IOS:</strong><br>Go Settings -> Select Browser -> Allow Camera</div>
                  <div><h6><b>Non Mobile Users:</b></h6></div>
                  <div><strong>Allow camera</strong> appearing in the url and click OK</div>
                  <button class="btn btn-primary" @click="showErrorModal = !showErrorModal">Ok</button>
                </div>
             </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Modal -->
    <div class="modal fade" id="upload-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Assignments Submission</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div id="pending">
              <div class="m-text-muted m--margin-bottom-15">
                <div class="alert alert-success" id="submit_success" style="display:none">Document has been uploaded successfully</div>
                <div class="alert alert-danger" id="submit_error" style="display:none"></div>
                <div class="alert alert-danger" v-if="this.dueDatePassed">Assignment submission date is due : {{this.dueDate}}</div>
                <div class="m-accordion m-accordion--bordered">
                  <form id="upload">
                    <div class="form-group m--margin-bottom-35">
                      <label for="">* Select Assignment</label>
                      <select name="assignment_id" id="assignmentSelectList" class="form-control" v-on:change="optionSelected($event)">
                        <option value="">Please select</option>
                        <option :value="item.assignment.id" v-for="(item, index) in this.assignments" :key="index">{{item.assignment.title}}</option>
                      </select>
                      <span id="assignment_error" style="display:none"  class="text-danger" >This field is required</span>
                    </div>
                    <div class="m-form-group form-group">
                      <label for="file">* Document</label>
                      <input type="file" class="form-control" id="file" name="document" capture="camera">
                      <div class="file-message">
                        Max file size <span>2MB</span> Supported file formats: <span>Word/Excel/PDF/CSV/PPT</span>
                      </div>
                      <span id="file_error" style="display:none" class="text-danger">This field is required</span>
                    </div>
                    <div class="m-form-group form-group">
                      <label for="">Comment</label>
                      <textarea class="form-control" id="comments" name="comments" rows="4" ></textarea>
                    </div>
                  </form>
                  <div class="m-portlet__foot">
                    <button class="btn btn-danger btn-info" id="submitBtn" @click="formSubmit">Upload</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Uploadedvideo from '@/components/template/Uploadedvideo'
import Vimeovideo from '@/components/template/Vimeovideo'
import Youtubevideo from '@/components/template/Youtubevideo'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

var Config = require('../router/Config')
var $ = require('jquery')
$(document).ready(function () {
  $('html body').on('contextmenu', function (e) {
    return false
  })
})

$(document).keydown(function (e) {
  if (e.which === 123) {
    return false
  }
  if (e.ctrlKey) {
    return false
  }
})
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

export default {
  name: 'topics',
  components: { Uploadedvideo, Vimeovideo, Youtubevideo, Loading },
  props: [],
  data () {
    return {
      api_url: Config.API_URL,
      document_url: Config.Documents_URL,
      assignment_url: Config.Assignment_URL,
      topic_details: [],
      documents: [],
      assignments: [],
      assignmentCount: 0,
      meterialCount: 0,
      quizCount: 0,
      uploads: [],
      quizAnswerDetails: [],
      isQuiz: false,
      videoId: '',
      videoType: '',
      videopPlayPending: true,
      videoPlayCompleted: false,
      constraints: {
        audio: false,
        video: { width: 1280, height: 720 }
      },
      showErrorModal: false,
      topicCompleteId: '',
      topicCompleteStatus: false,
      dueDatePassed: false,
      dueDate: '',
      course_name: Cookies.get('courseName'),
      course_duration: 0,
      isLoading: false,
      fullPage: true,
      // showQuizeButton: (Config.clientFeature) ? Config.clientFeature.showQuiz : false,
      showQuizeButton: false,
      // topicVideoFaceCapture: (Config.clientFeature) ? Config.clientFeature.topicVideoFaceCapture : true
      topicVideoFaceCapture: false
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  beforeMount: function (params) {
    if (userPermissions.show_quiz) {
      this.showQuizeButton = true
    }
    if (userPermissions.topic_video_face_capture) {
      this.topicVideoFaceCapture = true
    }
  },
  mounted () {
    this.getTopics()
    this.getSubmitQuestions()
    this.getSubmissions()
    this.isLoading = true
  },
  computed: {
  },
  methods: {
    getTopics: function () {
      this.axios.get(this.api_url + '/api/fe/topic/info/' +
        Cookies.get('topicId') + '/' +
        Cookies.get('courseId') + '?token=' +
        Cookies.get('accessToken')
      ).then(response => {
        this.topic_details = response.data.data
        this.documents = this.topic_details.documents
        this.assignments = this.topic_details.assignments
        this.videoType = this.topic_details.video_type
        this.assignmentCount = this.assignments.length
        this.meterialCount = this.documents.length
        this.quizCount = this.topic_details.questions_count
        this.course_duration = this.topic_details.duration
        this.videoId = this.topic_details.video_code
        if (this.videoId !== null && this.topicVideoFaceCapture) {
          var self = this
          navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
            // console.log('mediaDevices : ' + stream)
          }).catch(function (err) {
            if (err) {
              self.showErrorModal = true
            }
          })
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getSubmitQuestions: function () {
      this.axios.get(this.api_url + '/api/fe/topic/complete-questions/' +
        Cookies.get('courseId') + '/' +
        Cookies.get('userId') + '/' +
        Cookies.get('subjectId') + '/' +
        Cookies.get('topicId') + '/' +
        Cookies.get('chapterId') + '?token=' +
        Cookies.get('accessToken')
      ).then(response => {
        var result = response.data
        this.quizAnswerDetails = result.data
        this.isQuiz = result.isQuiz
        var completeData = result.topicComplete
        if (completeData) {
          this.topicCompleteId = (completeData.id) ? completeData.id : ''
          this.topicCompleteStatus = completeData.complete_status
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getSubmissions: function () {
      this.axios.get(this.api_url + '/api/fe/topic/assignment-uploads/' +
        Cookies.get('userId') + '/' +
        Cookies.get('courseId') + '/' +
        Cookies.get('topicId') + '?token=' +
        Cookies.get('accessToken')
      ).then(response => {
        // console.log('getSubmissions')
        // console.log(response.data.data)
        this.uploads = response.data.data
        this.isLoading = false
      }).catch(function (error) {
        console.log(error)
      })
    },
    formSubmit: function () {
      var assignment = $('#assignmentSelectList').val()
      var file = $('#file').val()
      $('#assignment_error').hide()
      $('#file_error').hide()
      if (assignment === '') {
        $('#assignment_error').show()
      }
      if (file === '') {
        $('#file_error').show()
      }
      var data = new FormData($('#upload')[0])
      data.append('topic_id', Cookies.get('topicId'))
      data.append('subject_id', Cookies.get('subjectId'))
      data.append('course_id', Cookies.get('courseId'))
      data.append('user_id', Cookies.get('userId'))
      data.append('chapter_id', Cookies.get('chapterId'))

      this.axios.post(this.api_url + '/api/fe/topic/upload-assignment' + '?token=' + Cookies.get('accessToken'), data).then(response => {
        if (response.data.res === 1) {
          $('#assignmentSelectList').val('')
          $('#file').val('')
          $('#comments').val('')
          this.getSubmissions()
          $('#submit_success').fadeTo(5000, 500).slideUp(500, function () {
            $('#submit_success').slideUp(500)
          })
        }
        // this.quizAnswerDetails = response.data.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    goBacktoChapters: function () {
      Cookies.get('subjectId')
      this.$router.replace({ name: 'chapters' })
    },
    changeVideoDesc: function () {
      this.videopPlayPending = false
      this.videoPlayCompleted = true
    },
    goToQuiz: function () {
      this.$router.replace({ name: 'topic_quiz' })
    },
    setCompleteTopic: function () {
      this.topicCompleteStatus = !this.topicCompleteStatus
      var self = this
      this.axios.post(this.api_url + '/api/fe/topic/complete' + '?token=' + Cookies.get('accessToken'), {
        complete_id: this.topicCompleteId,
        user_id: Cookies.get('userId'),
        topic_id: Cookies.get('topicId'),
        chapter_id: Cookies.get('chapterId'),
        subject_id: Cookies.get('subjectId'),
        course_id: Cookies.get('courseId'),
        status: self.topicCompleteStatus
      }).then(response => {
        self.topicCompleteId = response.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    scrollToElement: function (elementId) {
      $('div.body_content_block.m-content').animate({
        scrollTop: $('#' + elementId).offset().top - 70
      }, 1000)
    },
    optionSelected: function (e) {
      const id = e.target.value
      this.assignments.forEach(element => {
        if (element.assignment_id == id) {
          this.dueDate = element.due_date
          const today = this.currentDate()

          if (this.dueDate < today) {
            this.dueDatePassed = true;
          } else {
            this.dueDatePassed = false;
          }
        }
      })
    },
    currentDate: function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
  }
}
</script>
<style scoped lang="scss">
  @import "../assets/scss/component/topic/topic";
  @import "../assets/scss/component/switch/switch";
</style>
